import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectDataState } from '../../Store/selectors';

import {
    getInDataState,
    setInDataState,
    deleteInDataState,
    setFinalPriceInTarifsState
} from '../../Utils/storeHelpers';

import { beautifulGetLabel } from '../../Utils/labels';
import { formatPrice } from '../../Utils/price';
import { getTarifsInfoByTarifsName } from '../../Utils/jsonInterpreter';

const Container = styled.div`
    width: 100%;
    padding: 12px 15px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    ${props => props.disabled && 'opacity: 0.5; cursor: default;'}
`;

const Left = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const Checkbox = styled.div`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #999;
    position: relative;
    flex-shrink: 0;

    ${props => props.checked && `
        border-color: #000;
        background: #BED000;
       
        }
    `}
`;

const Label = styled.div`
    font-size: 14px;
`;

const Right = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const QuantityWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const QuantityLabel = styled.span`
    font-size: 13px;
    color: #666;
`;

const Quantity = styled.input`
    width: 45px;
    padding: 4px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 4px;
`;
const Price = styled.div`
    font-weight: bold;
    display: flex;
    gap: 4px;
    align-items: center;
`;

const PriceValue = styled.span`
    color: #BED000;
`;

const PriceUnit = styled.span`
    color: #999;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
`;
const LinearOption = props => {
    const dataState = useSelector(selectDataState);

    const [checked, setChecked] = useState(false);
    const [quantity, setQuantity] = useState(1);

    const checkedPath = `${props.pathInDataState}.${props.name}`;
    const quantityPath = props.pathInDataStateQuantity;

    const tarifsInfo = getTarifsInfoByTarifsName(props.tarifsName ?? props.name);
    const previsiteType = getInDataState("offre-previsite.smartpix-pro.type");

    useEffect(() => {
        const isChecked = getInDataState(checkedPath) ?? false;
        setChecked(isChecked);
    }, [dataState, checkedPath]);

    useEffect(() => {
        if (quantityPath) {
            const storedQty = getInDataState(quantityPath);
            setQuantity(storedQty ?? 1);
        }
    }, [dataState, quantityPath]);

    const handleClick = useCallback(() => {
        if (props.disabled) return;

        const newChecked = !checked;

        setInDataState(checkedPath, newChecked);

        if (quantityPath) {
            if (newChecked) {
                const currentQty = getInDataState(quantityPath);
                if (currentQty === undefined || currentQty === null) {
                    setInDataState(quantityPath, 1);
                    setQuantity(1);
                }
            } else {
                deleteInDataState(quantityPath);
                setQuantity(1);
            }
        }
    }, [props, checked, checkedPath, quantityPath]);

    const handleQuantity = useCallback((e) => {
        e.stopPropagation();

        const value = parseInt(e.target.value, 10) || 1;
        setQuantity(value);

        if (quantityPath) {
            setInDataState(quantityPath, value);
        }
    }, [quantityPath]);

    const shouldRender = !props.visibleFor || props.visibleFor.includes(previsiteType);

    if (!shouldRender) {
        return null;
    }

    return (
        <Container onClick={handleClick} disabled={props.disabled}>
            <Left>
                <Checkbox checked={checked} />
                <Label>
                    {beautifulGetLabel(props.label ?? props.name)}
                </Label>
            </Left>

            <Right>
                {quantityPath && checked && (
                    <QuantityWrapper>
                        <QuantityLabel>{props.quantityLabel} :</QuantityLabel>
                        <Quantity
                            type="number"
                            min={1}
                            value={quantity}
                            onChange={handleQuantity}
                            onClick={(e) => e.stopPropagation()}
                        />
                    </QuantityWrapper>
                )}
                <Price>
                    {tarifsInfo && typeof tarifsInfo.price === 'number' ? (
                        <>
                            <PriceValue>
                                {formatPrice(tarifsInfo.price)}
                            </PriceValue>
                            <PriceUnit>
                                HT {tarifsInfo.priceUnit?.toUpperCase()}
                            </PriceUnit>
                        </>
                    ) : (
                        props.price
                    )}
                </Price>
            </Right>
        </Container>
    );
};

export default LinearOption;